

import { useNavigate } from 'react-router-dom';
import StickButtonsBloc from '../../blocs/common/StickButtonsBloc';
import { APP_URLS } from '../../const/AppConst';
import useAppState from '../../context/AppContext';
import MgpFormInput from '../../elements/MgpFormInput/MgpFormInput';
import { isPropositionInLock } from '../../utils/dataUtils';
import { formatDateFR } from '../../utils/utils';


export default function InfoPersoStep0FormComponent() {

  const navigate = useNavigate();

  const {
    state: { proposition },
    dispatch,
  } = useAppState();

  const onNextAction = () => {
    dispatch({type: 'NEXT_INFO_STEP', path: APP_URLS.infoPersoStep1Page});
    navigate({
      pathname: APP_URLS.infoPersoStep1Page,
      search: `?id=${proposition!.propositionId}`,
    }); 
    
  }
  const onPreviousAction = () => {
    navigate({
      pathname: APP_URLS.bienvenuePage,
      search: `?id=${proposition!.propositionId}`,
    }); 
  }


    return (
      <> 
    { proposition?.configuration.hasShowPriceAmount === true &&
      <form style={{width: '100%'}}>
          
        <div className="form-row">          
            <div className="form-group mw-33">
            <MgpFormInput
                  label="Date de prise d’effet"
                  id="effectiveDate"
                  labelFontWeight='regular'
                  disabled={true}
                  value={proposition?.effectiveDate
                    ? formatDateFR(proposition?.effectiveDate)
                    : ""}
              />
            </div>
            <div className="form-group mw-33">
              <MgpFormInput
                  label="Formule"
                  id="principalProductName"
                  labelFontWeight='regular'
                  disabled={true}
                  value={proposition?.principalProductName}
              />
          </div>
         
            <div className="form-group mw-33">
              <MgpFormInput
                  label="Votre part de cotisation"
                  id="tarrif"
                  labelFontWeight='regular'
                  disabled={true}
                  value={`${proposition?.totalAmount} €`}
              />
            </div>   
          
                             
        </div>
          
        {proposition && isPropositionInLock(proposition) ? (<StickButtonsBloc disabledPreviousButton={true} showNextButton={true} showPreviousButton={true} previousAction={onPreviousAction} nextAction={onNextAction}/> ) : (<StickButtonsBloc showNextButton={true} showPreviousButton={true} previousAction={onPreviousAction} nextAction={onNextAction}/>)}
        <div>
        </div>
      </form>
    }
      </>
  )
}
